import { render, staticRenderFns } from "./LocationForm.vue?vue&type=template&id=b9bb710c&scoped=true&"
import script from "./LocationForm.vue?vue&type=script&lang=js&"
export * from "./LocationForm.vue?vue&type=script&lang=js&"
import style0 from "./LocationForm.vue?vue&type=style&index=0&id=b9bb710c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bb710c",
  null
  
)

export default component.exports